import { IStoreFilterItem } from '@/bundles/GroupFilters/interfaces/IStoreFilterItem';
import { SourceTypeEnum } from '@/bundles/App/enums';

export const GROUP_FILTERS_SOURCE_KEYS = [
  'property', 'availability', 'comparable', 'deal', 'contact',
  'company', 'pipeline', 'occupier', 'savedSet', 'requirement',
  'project', 'request', 'eblast', 'signList', 'pressrelease',
  'member', 'team', 'marketingCampaign', 'marketingTemplates', 'customRows',
  'document', SourceTypeEnum.comparablesDashboard
];

export interface IGroupFilterItem {
  [key: string]: IStoreFilterItem;
}
export interface IGroupFilters {
  [groupId: string]: IGroupFilterItem;
}

export interface IFiltersOptions {
  [key: string]: boolean;
}

interface IFilterObjectShape {
  filters: IGroupFilters;
  keyword: string;
  filterName: string;
  filterId: string;
  lastSelectedType: string;
  savedSetId: string;
  options: IFiltersOptions;
}

export const FILTER_OBJECT_SHAPE: IFilterObjectShape = {
  filters: {},
  keyword: '',
  filterName: '',
  filterId: '',
  lastSelectedType: '',
  savedSetId: '', // todo: check if filterId can be used
  options: {},
};

export const getDefaultGroupFilterObjectShape = (): IFilterObjectShape => {
  return Object.assign({}, FILTER_OBJECT_SHAPE);
}
